/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconAirConditioning = createReactComponent("air-conditioning", "IconAirConditioning", [
  ["path", { d: "M8 16a3 3 0 0 1 -3 3", key: "svg-0" }],
  ["path", { d: "M16 16a3 3 0 0 0 3 3", key: "svg-1" }],
  ["path", { d: "M12 16v4", key: "svg-2" }],
  [
    "path",
    {
      d: "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z",
      key: "svg-3"
    }
  ],
  ["path", { d: "M7 13v-3a1 1 0 0 1 1 -1h8a1 1 0 0 1 1 1v3", key: "svg-4" }]
]);

export { IconAirConditioning as default };
//# sourceMappingURL=IconAirConditioning.js.map
